import { ErrorHandler, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BusinessFinderService } from './business-finder.service';
import { RentalSalesResult } from '../models/rental-sales-result.model';
import { LatLon } from '../../util/geodesy/latlon';
import { BoundingBox } from '../../util/geodesy/bounding-box';

/**
 * HTTP service for the Rentals/Sales Finder. Calls the AirportsAPI `~/rental-sales` endpoint. Category facet
 * filtering (Aircraft Rental / Sales / ...) is applied client-side in {@link SearchPageComponent}; this
 * service performs only the location/state/keyword query.
 */
@Injectable({
  providedIn: 'root'
})
export class RentalSalesService extends BusinessFinderService<RentalSalesResult> {

  protected readonly endpoint = 'rental-sales';

  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  protected parse(data: any): RentalSalesResult {
    return RentalSalesResult.parse(data);
  }

  getRentalSalesByLatLon(latlon: LatLon, radius: number): Promise<RentalSalesResult[]> {
    return this.getByLatLon(latlon, radius);
  }

  getRentalSalesByBoundingBox(bounds: BoundingBox): Promise<RentalSalesResult[]> {
    return this.getByBoundingBox(bounds);
  }

  getRentalSalesByState(state: string): Promise<RentalSalesResult[]> {
    return this.getByState(state);
  }

  getRentalSalesBySearchTerm(term: string): Promise<RentalSalesResult[]> {
    return this.getBySearchTerm(term);
  }
}
